import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { AdSubCategoriesTable } from "../../UI/AdSubCategories/AdSubCategoriesTable";

const AdSubCategories = () => {
  return (
    <div>
      <PanelHead title="AdSubCategories" />
      <PanelBody content={<AdSubCategoriesTable />} />
    </div>
  );
};

export default AdSubCategories;
